module.exports = __webpack_public_path__ + "img/wxdj-head.5a131b7c.png";